// @ts-nocheck
import React from 'react';
import Content from 'components/Content';
import Section from 'components/Section';

const PenlyAccessNewFeatures = () => (
    <Content>
        <Section title="Nye features">
            <p>
                Her samler vi nye funktioner og produktopdateringer i Teal Business.
            </p>
            <p>
                Der er ikke nogen nye features at vise endnu.
            </p>
        </Section>
    </Content>
);

export default PenlyAccessNewFeatures;
